import Routing from "./Routes/Routing";
import "react-toastify/dist/ReactToastify.css";

// in App.js , rendered the routing component that handles the routes. 

function App() {
  return (
      <Routing />
  );
}

export default App;
